
<template>
  <v-app>
    <main-app-bar elevation="0" app-bar-color="" app-bar-text-color="">
    </main-app-bar>
    <v-main>
      <span>Fejlesztés alatt!!</span>
    </v-main>
  </v-app>
</template>
<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";

@Options({
  components: {
    MainAppBar

  },
  data() {
    return {
    };
  },
  methods: {

  }
})
export default class References extends Vue {

}
</script>

<style scoped>

</style>